module.exports = __webpack_public_path__ + "static/media/segula.429a6343.png";